<template>
  <div class="rowNewSection">
    <RowSectionForm
      v-if="isEdit"
      class="rowNewSection-form"
      :data="data"
      @submit="submit"
    />
    <div
      v-else
      class="rowNewSection-holder"
      @click="add"
    >
      <div class="rowNewSection-icon" />
      <!-- <div class="rowNewSection-text">
        Добавить дополнительную секцию
      </div> -->
    </div>
  </div>
</template>

<script>
	import RowSectionForm from './RowSectionForm';

	export default {
		components: {
			RowSectionForm
		},
		props: {
			data: Object,
		},
		data() {
			return {
				isEdit: false,
			};
		},
		methods: {
      add() {
        // this.isEdit = true;
        this.$emit('submit', {
          width: 700,
          count: 3,
        });
      },
			submit(data) {
				this.$emit('submit', data);
				this.isEdit = false;
			},
		},
	};
</script>

<style scoped>
	.rowNewSection {
		display: flex;
		flex-direction: column;
		/* align-items: center; */
		justify-content: center;
		padding: 16px 24px 32px;
		width: 98px;
		background: #F6F6F6;
		cursor: pointer;
	}
	.rowNewSection-form {
		flex: 1;
	}
	.rowNewSection-holder {
		text-align: center;
	}
	.rowNewSection-icon {
		display: inline-block;
		margin-bottom: 15px;
		width: 50px;
		height: 50px;
		background: #F58214 url(../../public/icons/sign.svg) no-repeat center center;
	}
	.rowNewSection-text {
		font-size: 14px;
		line-height: 16px;
	}
</style>
